import React from 'react';
import styled from 'styled-components';
import { mediaBreakpoint } from '@root/src/services/responsiveProvider';
import EventSidePanel from '@features/eventDetail/components/EventSidePanel';

const EventContentWithSidePanel = ({ children, hideSubscribeButton = false }) => (
  <Container>
    <StyledEventSidePanel hideSubscribeButton={hideSubscribeButton} />
    {children}
  </Container>
);

export default EventContentWithSidePanel;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;

  ${mediaBreakpoint.tablet} {
    flex-direction: column;
  }
`;

const StyledEventSidePanel = styled(EventSidePanel)`
  margin-right: 100px;
  /* otherwise flex will try to shrink our sidepanel as much as possible */
  min-width: 351px;
  max-width: 351px;

  ${mediaBreakpoint.tablet} {
    flex-direction: column;
    min-width: unset;
    max-width: unset;
    width: 100%;
    margin-bottom: 40px;
  }

`;
